import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownMenu, DropdownToggle, UncontrolledTooltip } from 'reactstrap';
import { Settings } from 'react-feather';
import { connect } from 'react-redux';

import _isEmpty from 'lodash/isEmpty';

import { sidebarController } from 'service/sidebar/action';
import { themeController } from 'service/theme/action';
import { projectController } from 'service/projectShifter/action';
import { enableReconRoutes, enableRefDataRoutes, getApplicationRoutes } from 'service/appconfiguration/action';
import './styles.scss';

class SettingsDropdown extends Component {
    constructor(props) {
        super(props);
        this.toggleDropdown = this.toggleDropdown.bind(this);
        this.state = {
            dropdownOpen: false,
            isRefData: _isEmpty(localStorage.getItem('isRefData')) ? false : localStorage.getItem('isRefData') === 'true',
        };
        this.props.getApplicationRoutes();
    }

    toggleDropdown() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen,
            theme: parseInt(localStorage.getItem('theme')),
        });
    }

    handleLangChange = (event) => {
        if (event.target.checked == true) {
            this.setState({ theme: 1 });
            localStorage.setItem('theme', 1);

            location.reload();
        } else {
            this.setState({ theme: 0 });
            localStorage.setItem('theme', 0);
            location.reload();
        }
    };

    render() {
        const tag = this.props.tag || 'div';
        const { isRefData } = this.state;
        const username = localStorage.getItem('username');
        const isTradeUser =
            (username === 'ta1user@ta.com' || username === 'ta2user@ta.com' || username === 'citiuser@citi.com');
        return (
            <React.Fragment>
                <Dropdown
                    style={{ marginBottom: '-10px' }}
                    isOpen={this.state.dropdownOpen}
                    toggle={this.toggleDropdown}
                    className="d-none d-lg-block"
                    tag={tag}
                >
                    <DropdownToggle
                        id="settingDropdown"
                        data-toggle="dropdown"
                        tag="a"
                        className="nav-link mr-0"
                        onClick={this.toggleDropdown}
                        aria-expanded={this.state.dropdownOpen}
                    >
                        <Settings />
                    </DropdownToggle>
                    <DropdownMenu right className="for-drop-down-menu">
                        <div className="for-sidebar-layout">
                            <label className="switch3">
                                <input type="checkbox" onChange={this.props.sidebarController} checked={this.props.sidebarStatus.sidebar} />
                                <span className="slider round" />
                            </label>
                            <div>Responsive Sidebar</div>
                        </div>
                        {/* {this.props.appDashboard === 'BlocData' && !isTradeUser && (
                            <div className="for-sidebar-layout">
                                <label className="switch3">
                                    <input
                                        type="checkbox"
                                        onChange={
                                            () =>
                                                this.setState({ isRefData: !isRefData }, () => {
                                                    localStorage.setItem('isRefData', !isRefData);
                                                    this.props.projectController();
                                                    if (!isRefData) {
                                                        this.props.enableRefDataRoutes();
                                                    } else {
                                                        this.props.enableReconRoutes();
                                                    }
                                                })
                                            //    () => { this.props.projectController()}
                                        }
                                        checked={isRefData}
                                    />
                                    <span className="slider round" />
                                </label>
                                <div> {isRefData ? 'Reference Dashboard' : ' Recon Dashboard'}</div>
                            </div>
                        )} */}
                        <div className="for-sidebar-layout">
                            <label className="switch3">
                                <input type="checkbox" onChange={this.handleLangChange} checked={this.state.theme} />
                                <span className="slider round" />
                            </label>
                            <div>Dark Theme</div>
                        </div>
                    </DropdownMenu>
                </Dropdown>
                <UncontrolledTooltip placement="left" target="settingDropdown">
                    Settings
                </UncontrolledTooltip>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        sidebarStatus: state.sidebarReducer,
        themeStatus: state.themeReducer,
        projectStatus: state.projectReducer,
        appDashboard: state.appConfigurationReducer.appDashboard,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        sidebarController: () => {
            dispatch(sidebarController());
        },
        themeController: () => {
            dispatch(themeController());
        },
        projectController: () => {
            dispatch(projectController());
        },
        enableReconRoutes: () => dispatch(enableReconRoutes()),
        enableRefDataRoutes: () => dispatch(enableRefDataRoutes()),
        getApplicationRoutes: () => dispatch(getApplicationRoutes()),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(SettingsDropdown);
